// Imports
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-cube';
import './scss/styles.scss';
import ReactDOM from 'react-dom/client';
import App from './Components/App';

// Root
const root = ReactDOM.createRoot(document.querySelector('#root'));

root.render(
    <App />
);
